const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

export function isValidAnonId(s: string): boolean {
  if (typeof s !== "string") return false;
  return UUID_V4_REGEX.test(s);
}

export type RandomUUID = { randomUUID: () => string };

export function generateAnonId(deps: RandomUUID): string {
  const id = deps.randomUUID();
  if (!isValidAnonId(id)) {
    throw new Error("generateAnonId: randomUUID() returned an invalid UUID v4");
  }
  return id;
}
